import { Num } from '../utils';
export class Dimensions {
public width: number;
public height: number;
/**
 * @param {?} width
 * @param {?} height
 */
constructor(width: number, height: number) {
    this.width = Num.isNaN(width) ? 0 : width;
    this.height = Num.isNaN(height) ? 0 : height;
  }
}

function Dimensions_tsickle_Closure_declarations() {
/** @type {?} */
Dimensions.prototype.width;
/** @type {?} */
Dimensions.prototype.height;
}
